module.exports = __webpack_public_path__ + "img/ht_icon_check.06a5e27f.svg";